import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, type ViewFetchState } from '@bliks-io/ui';

interface DialogLoadStateBodyProps {
  loadState: ViewFetchState;
  notFoundKey: string;
  skeleton: ReactNode;
}

export function DialogLoadStateBody({
  loadState,
  notFoundKey,
  skeleton
}: DialogLoadStateBodyProps) {
  const { t } = useTranslation();

  switch (loadState.status) {
    case 'unavailable':
      return (
        <div className="flex flex-col items-center gap-4 py-8">
          <p className="text-sm text-muted-foreground">{t(notFoundKey)}</p>
        </div>
      );
    case 'failed':
      return (
        <div className="flex flex-col items-center gap-4 py-8">
          <p role="alert" className="text-sm text-danger">
            {t('common.errorOccurred')}
          </p>
          <Button variant="outline" size="small" onClick={loadState.retry}>
            {t('common.retry')}
          </Button>
        </div>
      );
    case 'pending':
      return (
        <div role="status" aria-label={t('common.loading')} className="flex flex-col gap-4.5">
          {skeleton}
        </div>
      );
  }
}
